import { render, staticRenderFns } from "./resolveCase.vue?vue&type=template&id=159a512f"
import script from "./resolveCase.vue?vue&type=script&lang=js"
export * from "./resolveCase.vue?vue&type=script&lang=js"
import style0 from "./resolveCase.vue?vue&type=style&index=0&id=159a512f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports